import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { bridge } from "@multiweb/reactCore/bridge";
import { createUpdateFulltextDataSourceConditionAction } from "@multiweb/reactCore/datasource";
import { AnyConstructor, Mixin } from "Global/Base/types";
import { MenuUIExtensionProperties } from "UI/UI/UI/FormUI/FormUIShared";
import { FrameSharedMethods } from "UI/UI/UI/XGControls/Frames/FrameSharedMethods";
import { IFulltextSearchableFrame, IFulltextSearchCondition } from "../../UI/UI/XGControls/Frames/FrameInterfaces";
import { IReactFrameConnector } from "../types";

const { dispatchAction } = bridge;

const logger = LazyLoadingSectionLogger.create(LoggingSection.frames);

/**
 * Mixin, který přidává fulltext search na ConnectorFrame.
 *
 * @param Base Base třída rozšiřující IConnectorFrame.
 */
export const HasFulltextSearch = <T extends AnyConstructor<IReactFrameConnector>>(Base: T) =>
    class HasAutorefresh extends Base implements IFulltextSearchableFrame {
        /**
         * Atributy, které jsou definicí formuláře určeny pro fulltextové vyhledávání.
         */
        public fulltextAttributes: string[];
        /**
         * Podmínka pro fulltextové vyhledávání.
         */
        public fulltextCondition: IFulltextSearchCondition;
        /**
         * Podmínka z definice formuláře pro fulltextové vyhledávání.
         */
        public initalCondition: string;

        constructor(...args: any[]) {
            super(...args);

            const fulltextAttributesString = this.element.getAttribute("data-fulltextattrs");
            if (fulltextAttributesString) {
                this.fulltextAttributes = fulltextAttributesString.split(";");
                this.initalCondition = this.element.getAttribute("data-condition");
            }
        }

        public createReaderCondition(): Promise<string> {
            return new Promise<string>(() => { /* Prázdná arrow funkce */ });
        }

        /**
        * Aktualizuje podmínku datasource.
        */
        public async updateConditionAndRead(): Promise<void> {
            dispatchAction(
                createUpdateFulltextDataSourceConditionAction(this.element.id, this.fulltextCondition),
            );
        }

        public override async initializeVisual(): Promise<void> {
            await super.initializeVisual();

            if (this.fulltextAttributes) {
                logger.log(`Activate Fulltextsearch on Frame with id '${this.element.id}'`);
                this.menu.setProperty(MenuUIExtensionProperties.fulltextSupported, true);
                FrameSharedMethods.addFulltextSearch(this);
            }
        }
    };

export type HasFulltextSearch = Mixin<typeof HasFulltextSearch>;
